import * as types from "./mutation_types";
import axios from "axios";
import session from "@/kuaa/kuaa-sessions";

export default {
  [types.HOST](state, host) {
    state.host = host;
  },
  [types.USER_NO](state, userNo) {
    state.userNo = userNo;
  },
  [types.USER_NAME](state, userName) {
    state.userName = userName;
  },
  [types.LEVEL_CODE](state, levelCode) {
    state.levelCode = levelCode;
  },
  [types.IS_AUTH](state, isAuth) {
    state.isAuth = isAuth;
  },
  [types.ACCESS_TOKEN](state, token) {
    state.accessToken = token;
  },
  [types.REFRESH_TOKEN](state, token) {
    state.refreshToken = token;
  },

  [types.LOGIN_INFO](state, data){
    state.isAuth = true;
    state.userNo = data.userNo;
    state.userName = data.userName;
    state.levelCode = data.levelCode;
    state.accessToken = data.token;
  },

  loginFailure: function(state) {
    state.isAuth = false;
    state.userNo = "";
    state.userName = "";
    state.levelCode = "";
    state.accessToken = "";
  },
  logout: function(state) {
    if (state.isAuth) {
      state.isAuth = false;
      state.userNo = "";
      state.userName = "";
      state.levelCode = "";
      state.accessToken = "";
      session.clear();
    }
  },
  loginCheck: function(state) {
    axios
      .post(`${state.host}/api/auth/authCheck.do`, {
        headers: {
          "X-Auth-Token": state.token
        }
      })
      .then(response => {
//        console.log(response);
        //console.log(response.data.token.role);
      })
      .catch(error => {
//        console.log("failed", error);

        this.$router.push({ path: "/login" });
      });
  },
  setToken(state, token){
    state.accessToken = token;
  },
  setLoginInfo(state, resData){
    state.isAuth = false;
    state.userNo = resData.userNo;
    state.userName = resData.userName;
    state.levelCode = resData.levelCode;
    state.accessToken = resData.accessToken;
  }
};
